<app-mobile-header></app-mobile-header>

<main [@routeAnimations]="animationState" appSwipeBack class="pt-16 pb-20"> <!-- Padding top for header, padding bottom for tab nav -->
  <router-outlet (activate)='onOutletLoaded($event)' #outlet="outlet"></router-outlet>
</main>

<app-footer></app-footer>

<app-bottom-tab-nav></app-bottom-tab-nav>
